<template>
  <v-card class="mb-3">
    <v-card-title>
      Team Information
    </v-card-title>
    <v-card-text>

      <v-text-field v-model="form.name"
                    label="Team Name"
                    :rules="[rules.required]"
                    :errors="form.errors.get('name')">
      </v-text-field>

      <v-select v-model="form.owner_id"
                label="Primary contact"
                :items="activeUsers"
                item-value="id"
                item-text="name"
                :rules="[rules.required]"
                :errors="form.errors.get('owner_id')"
                required>
      </v-select>

    </v-card-text>
  </v-card>
</template>
<script>
import {mapGetters} from 'vuex';
import formValidation from '../../../plugins/formValidation';

export default {
  mixins: [
    formValidation
  ],
  props: {
    form: {
      type: Object,
      required: true,
    }
  },
  computed: {
    ...mapGetters([
      'activeUsers',
      'team',
    ]),
  },
  created() {
    this.$store.dispatch('fetchUsers');
  }
}
</script>
